// @flow strict

import React, { type Node } from 'react';
import { useLanguageContext } from '~contexts/language-context';

import * as styles from './audio.module.less';

/**
 * Type of component properties
 */
type AudioProps = {
  src: string,
  title?: string,
};

/**
 * Render the audio tag with default settings and the passed src.
 *
 * @param {AudioProps} props - Component properties
 *
 * @returns {Node}
 */
export const Audio = ({ src, title }: AudioProps) => {
  const { loc } = useLanguageContext();

  return (
    <div className={styles.wrapper}>
      <figure>
        {title != null && <figcaption>{title}</figcaption>}

        <audio controls preload="metadata" src={src}>
          <a rel="noreferrer noopener" href={src}>
            {loc('_audio_fallback')}
          </a>
        </audio>
      </figure>
    </div>
  );
};
